var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-wrap"
  }, [_c('div', {
    staticClass: "wrap pt-20 pb-20"
  }, [_c('div', {
    staticClass: "big_screen_show container"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "clearfix fs-20"
  }, _vm._l((_vm.menuList), function(v, i) {
    return _c('li', {
      key: i,
      staticClass: "pr fl",
      on: {
        "mouseover": function($event) {
          return _vm.mouseOver(i)
        },
        "mouseleave": _vm.mouseLeave
      }
    }, [_c('div', {
      staticClass: "flex_item_con"
    }, [_c('a', {
      class: ['color-fff', {
        navActive: i == _vm.navActiveIndex
      }],
      on: {
        "click": function($event) {
          return _vm.handleClickPcMenu(i)
        }
      }
    }, [_vm._v(_vm._s(v.title))])]), _vm._v(" "), (v.subMenu) ? [(_vm.mouseOverIndex == i && _vm.showSubNac) ? _c('div', {
      ref: "subNav ",
      refInFor: true,
      staticClass: "pa subNav"
    }, _vm._l((v.subMenu), function(sv, si) {
      return _c('li', {
        key: si,
        staticClass: "mt-20 mb-20 fs-16"
      }, [_c('img', {
        staticClass: "mr-10",
        staticStyle: {
          "width": "6px"
        },
        attrs: {
          "src": require("../assets/img/icon_dot.png")
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "flex_item_con"
      }, [_c('a', {
        staticClass: "ml-10 color-666",
        on: {
          "click": function($event) {
            return _vm.handleClickPcSubMenu(i, sv)
          }
        }
      }, [_vm._v(_vm._s(sv.subTitle))])])])
    }), 0) : _vm._e()] : _vm._e()], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "lauguage_wrap"
  }, [_c('div', {
    staticClass: "wrap_item borders",
    on: {
      "click": function($event) {
        return _vm.changeLanguage('zh')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/cn.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("简体中文")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_item",
    on: {
      "click": function($event) {
        return _vm.changeLanguage('en')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/us.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("English")])])]), _vm._v(" "), _c('div', {
    staticClass: "small_screen_show"
  }, [_c('i', {
    staticClass: "el-icon-menu",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.showMobile = !_vm.showMobile
      }
    },
    slot: "reference"
  })]), _vm._v(" "), (_vm.showMobile) ? _c('div', {
    staticClass: "menu-mask",
    on: {
      "click": function($event) {
        _vm.showMobile = false
      }
    }
  }, [_c('div', {
    staticClass: "menu_list"
  }, _vm._l((_vm.smenuList), function(item, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.handelJump(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.en))])])
  }), 0)]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo_wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png"),
      "alt": ""
    }
  })])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5ba8af2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageTop.vue
// module id = null
// module chunks = 